/* eslint-disable max-len */
jQuery(document).ready(function($) {
  'use strict';

  if ($('.js-switch-block').length) {
    let cookieName = '';

    // eslint-disable-next-line max-statements
    $('.switch-btn').on('click', function() {
      var section = $(this).parent()
                           .parent()
                           .parent();

      if (section.hasClass('js-switch-all')) {
        $('.switch-btn').parent()
                                     .parent()
                                     .parent()
                                     .attr('data-active-tab', $(this).data('tab'));
        $('.switch-btn').removeClass('is-active');
        $('.switch-btn[data-tab="' + $(this).data('tab') + '"]').addClass('is-active');
      } else {
        section.attr('data-active-tab', $(this).data('tab'));
        $(this).parent()
               .children('.switch-btn')
               .removeClass('is-active');
        $(this).addClass('is-active');
      }

      if (cookieName !== '' && cookieName !== 'switch.') {
        document.cookie = cookieName + '=' + $(this).data('tab') + '; path=/;';
      }
    });
  }
});
